var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ChartCard"}},[_c('h2',[_vm._v(_vm._s(_vm.name))]),_c('canvas',{ref:"myChart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }